module.exports = __webpack_public_path__ + "static/media/woman-with-long-hair .69a7becb.svg";